<script setup lang="ts">
defineOptions({
  name: "login"
});

  import { onMounted, ref } from "vue";
  import { useLoading } from "@sa/hooks";
  import { useRouter } from "vue-router";
  import { handlePingPong } from "@/service/request/shared";
  import { $t } from "@/locales";
  const router = useRouter();
  const { startLoading, endLoading } = useLoading();

  const showLogin = ref(false);

  onMounted(async () => {
    startLoading();
    const result = await handlePingPong();
    if (result) {
      showLogin.value = false;
      router.push("/home");
    } else showLogin.value = true;
    endLoading();
  });
  const handlePositiveClick = () => {
    startLoading();
    window.location.href = "/chat?redirect=/platform/home&show=login";
  };
  const handleNegativeClick = () => {
    startLoading();
    router.push("/home");
  };
</script>

<template>
  <div v-if="showLogin" class="relative size-full flex-center overflow-hidden">
    <NDialog
      closable
      transform-origin="center"
      class="rounded-lg bg-white text-right shadow-lg dark:bg-gray-700 dark:text-gray-200"
      :action-style="{ justifyContent: 'space-between' }"
      :content="$t('page.login.common.needLogin')"
      :negative-text="$t('page.login.common.back')"
      :positive-text="$t('page.login.common.login')"
      @close="handleNegativeClick"
      @negative-click="handleNegativeClick"
      @positive-click="handlePositiveClick"
      @mask-click="handleNegativeClick"
    />
  </div>
</template>
